interface IParsedAddressMetadata {
    categories: Set<string>,
    owners: Set<string>,
    identities: Map<string, IIdentityObject>,
    address: string
}

type ImportEmitName = "import-finished" | "import-start" | "close-modal"
type ImportEmitType = (eventName: ImportEmitName, event?: number) => void

enum ImportFormat {
    Standard,
    Case
}

interface IEntry {
    address: string,
    crypto: string,
    identities: IIdentityObject[],
    categories: any[],
    owners: any[]
}

interface IEntryFormattedForImport {
    address: string,
    identities: IIdentityObject[],
    categories: string[],
    owners: string[]
}

interface IIdentityObject {
    label: string,
    source?: string,
    url?: string
}

interface IRow {
    crypto: string,
    address: string,
    label: string,
    source?: string,
    url?: string,
    categories: string[],
    owners: string[]
}

interface IFormattedAndValidatedData {
    currencyToItems: ICurrencyToItems,
    invalidRows: IRow[]
}

type ICurrencyToItems = Map<string, IEntryFormattedForImport[]>

type ImportRequestCallback = (value: IEntryFormattedForImport[], key: string) => Promise<boolean>

type AddressImportError = { validationErrors: object, userFriendlyMessage: string }

export {
    ImportFormat,
    IFormattedAndValidatedData,
    IIdentityObject,
    IRow,
    ICurrencyToItems,
    IEntry,
    IParsedAddressMetadata,
    ImportEmitType,
    IEntryFormattedForImport,
    ImportRequestCallback,
    AddressImportError
};